<template>
  <div class="flex w-full h-full mx-auto p-6">
    <div
      class="bg-white shadow-lg rounded-lg w-2/6 mx-4 pt-4 pb-48 px-4 overflow-hidden"
      style="padding-bottom: 20rem"
    >
      <div class="flex items-center pb-4">
        <h3
          class="flex items-center font-bold text-gray-900 px-2 py-2 leading-tight tracking-wider"
        >
          Lista de proyectos
          <span
            class="rounded-full ml-2 border-solid border-2 border-gray-300 px-3 py-1 bg-gray-100"
          >{{filteredRaising.length}}</span>
        </h3>
        <button class="border-2 rounded border-gray-700" @click="changeRaisingOrder">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 fill-current" viewBox="0 0 24 24">
            <path d="M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z" />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </button>
      </div>
      <input
        type="text"
        v-model="search"
        placeholder="Búsqueda de proyectos"
        class="w-full appearance-none border rounded py-2 px-3 mb-1 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
      />
      <div class="w-full">
        <div class="w-full relative">
          <select
            class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 mb-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            name="status"
            id="status"
            v-model="categoryFilter"
            @change="updateSelectRegister()"
          >
            <option selected value="-1">Todos</option>
            <template v-for="category in categories">
              <option :key="category.id" :value="category.id">{{category.nombre}}</option>
            </template>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
          >
            <svg
              class="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
      <div class="w-full flex">
        <button
          v-on:click="statusFilterRaising = 'TODOS', filteredRaising, updateSelectRegister()"
          class="w-full hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterRaising === 'TODOS' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color-dark']"
        >Todos {{filteredRaisingByAll.length}}</button>
      </div>
      <div class="w-full flex">
        <button
          v-on:click="statusFilterRaising = 'NO REVISADOS', filteredRaising, updateSelectRegister()"
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-t border-l border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterRaising === 'NO REVISADOS' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color-dark']"
        >EN PROCESOS {{filteredRaisingByOpen.length}}</button>
        <button
          v-on:click="statusFilterRaising = 'RECHAZADOS', filteredRaising, updateSelectRegister()"
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterRaising === 'RECHAZADOS' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color-dark']"
        >RECHAZADOS {{filteredRaisingByCanceled.length}}</button>
      </div>
      <div class="w-full flex pb-2">
        <button
          v-on:click="statusFilterRaising = 'EN REVISIÓN', filteredRaising, updateSelectRegister()"
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-l border-r border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterRaising === 'EN REVISIÓN' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color-dark']"
        >EN REVISIÓN {{filteredRaisingByAssigned.length}}</button>
        <button
          v-on:click="statusFilterRaising = 'APROBADOS', filteredRaising, updateSelectRegister()"
          class="w-1/2 hover:bg-secondary-color font-semibold hover:text-white py-2 px-4 border-r border-b border-secondary-color-dark hover:border-transparent rounded"
          v-bind:class="[statusFilterRaising === 'APROBADOS' ? 'border-transparent bg-secondary-color text-white' : 'bg-transparent text-secondary-color-dark']"
        >APROBADOS {{filteredRaisingByAttended.length}}</button>
      </div>
      <div class="h-full overflow-auto">
        <div
          v-for="one_raising in filteredRaising"
          :key="one_raising.id"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{'bg-secondary-color font-bold': one_raising.id === currentProject.id}"
          @click="selectRaising(one_raising)"
        >
          <img :src="one_raising.path_media_folder" class="h-12 w-12 object-cover" @error="loadDefaultImg" />
          <div class="flex flex-col flex-grow ml-2" >
            <span
              :class="[one_raising.id === currentProject.id ? 'text-gray-100' : 'text-gray-900']"
              class="group-hover:text-gray-900"
            >{{ one_raising.titulo }}</span>            
            <span
              :class="[one_raising.id === currentProject.id ? 'text-gray-100' : 'text-gray-900']"
              class="group-hover:text-gray-900"
            >{{ one_raising.fecha_creacion | moment('DD/MM/YYYY hh:mm A')}}</span>
            <span
              :class="[one_raising.id === currentProject.id ? 'text-gray-300' : 'text-gray-700']"
              class="text-sm group-hover:text-gray-700"
            >{{ one_raising.institucion }}</span>
            <span
              :class="[one_raising.id === currentProject.id ? 'text-gray-300' : 'text-gray-700']"
              class="text-sm group-hover:text-gray-700"
            >F-{{ one_raising.id }} {{ one_raising.status }}</span>
          </div>
          <div 
            v-if="one_raising.en_pausa === true"
            class="flex self-start justify-self-end text-xs"
            >
            <div 
              class="px-3 py-1 rounded-full border-2 border-blue-700 text-xs text-white bg-blue-500"
            >En pausa</div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden">
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full">
          <div class="flex pb-2">
            <h1
              class="pb-1 text-left font-bold tracking-widest text-neutral-100"
            >{{currentProject.titulo}}</h1>
          </div>
          <div class="pb-2 w-full text-right">
            <a
              v-if="currentProject.geometria !== null"
              id="downGeojson"
              v-on:click="toGeojsonFile()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >Geojson</a>

            <a
              v-if="currentProject.geometria !== null"
              id="downKML"
              v-on:click="toKMLFile()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >KML</a>         

            <a
              v-if="currentProject.geometria !== null"
              id="downSHP"
              v-on:click="toSHPFile()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >Shapefile (zip)</a>      
              <button
              class="bg-transparent hover:bg-red-500 text-danger-color font-semibold hover:text-white py-2 px-4 mx-1 border border-danger-color hover:border-transparent rounded"
              @click="showingDeleteConfirm = true"
            >
              Eliminar
            </button>           
          </div>
          <div class="flex">
            <div class="h-80 w-full">
              <l-map
                ref="map"
                class="h-full w-full z-0"
                :zoom="zoom"
                :minZoom="4"
                :center="center"
                :options="{zoomControl: true}"
                @ready="onMapReady"
              >
                <!-- <l-geo-json :geojson="polygon" :options-style="geoStyle" /> -->
                <l-tile-layer :url="urlBasemap" :attribution="attribution"></l-tile-layer>
                <l-geo-json v-if="geojsonRouter" :geojson="geojsonRouter" />
              </l-map>
            </div>
          </div>


          <!--seccion de informacion -->
          <div class="flex w-full">
            <div
              class="flex flex-col w-11/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
            >
              <p
                class="pb-1 pt-2 text-sm text-center font-bold tracking-widest"
              >
                Información del proyecto
              </p>            
              <div class="flex items-center">
                <div class="flex items-center w-1/2 text-left text-xs">
                  <div
                    v-if="currentProject.status === 'NO REVISADO'"
                    class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                  >F-{{currentProject.id}} EN PROCESO</div>
                  <div
                    v-if="currentProject.status === 'RECHAZADO'"
                    class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                  >F-{{currentProject.id}} {{ currentProject.status }}</div>
                  <div
                    v-if="currentProject.status === 'EN REVISIÓN'"
                    class="px-3 py-1 rounded-full border-2 border-orange-700 text-white bg-orange-500 tracking-widest font-bold"
                  >F-{{currentProject.id}} {{ currentProject.status }}</div>
                  <div
                    v-if="currentProject.status === 'APROBADO'"
                    class="px-3 py-1 rounded-full border-2 border-green-700 text-white bg-green-500 tracking-widest font-bold"
                  >F-{{currentProject.id}} {{ currentProject.status }}</div>
                  <div class="pl-2">
                    <div
                      v-if="currentProject.activo === true"
                      class="px-3 py-1 rounded-full border-2 border-blue-700 text-white bg-blue-500 tracking-widest font-bold"
                    > Activo</div>
                    <div
                      v-if="currentProject.activo === false"
                      class="px-3 py-1 rounded-full border-2 border-red-700 text-white bg-red-500 tracking-widest font-bold"
                    > Desactivado</div>
                  </div>
                </div>
                <div
                  class="w-1/2 text-right text-xs text-gray-900"
                >{{ currentProject.fecha_creacion | moment('DD/MM/YYYY hh:mm a') }}</div>
              </div>
              <br>
              <div class="flex w-full text-xs pt-2 tracking-wide">
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left">
                  <span class="font-bold">Nombre del proyecto:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify">
                  {{ currentProject.nombre }}
                </div>
              </div>

              <div class="flex w-full text-xs pt-2 tracking-wide">
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left">
                  <span class="font-bold">Institución:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify">
                  {{ currentProject.institucion }}
                </div>
              </div>

              <div class="flex w-full text-xs pt-2 tracking-wide ">
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left">
                  <span class="font-bold">Líder de proyecto:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify">
                  {{ currentProject.lider }}
                </div>
              </div>              

              <div class="flex w-full text-xs pt-2 tracking-wide ">
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left">
                  <span class="font-bold">Descripción:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify">
                  {{ currentProject.descripcion }}
                </div>
              </div>

 <!--              <div class="flex w-full text-xs pt-2 tracking-wide ">
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left">
                  <span class="font-bold">Objetivo:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify">
                  {{ currentProject.objetivo }}
                </div>
              </div>   -->

<!--               <div class="flex w-full text-xs pt-2 tracking-wide ">
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left">
                  <span class="font-bold">Especificaciones de la fotografía:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify">
                  {{ currentProject.especificaciones_multimedia }}
                </div>
              </div>   --> 

<!--               <div class="flex w-full text-xs pt-2 tracking-wide ">
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left">
                  <span class="font-bold">Producto:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify">
                  {{ currentProject.producto }}
                </div>
              </div>  -->                                     

              <div
                class="flex w-full text-xs pt-2 tracking-wide "
                v-if="currentProject.activo === true"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left">
                  <span class="font-bold">Creado por:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify">
                  {{ currentProject.nombre_propietario }} {{ currentProject.apellido_propietario }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide "
                v-if="currentProject.activo === true"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left">
                  <span class="font-bold">Fecha de creación:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify">
                  {{ currentProject.fecha_creacion | moment('DD/MM/YYYY hh:mm a') }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide "
                v-if="currentProject.activo === false"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left">
                  <span class="font-bold">Desactivado por:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify">
                  {{ currentProject.nombre_curador_desactivate }} {{ currentProject.apellido_curador_desactivate }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide"
                v-if="currentProject.activo === false"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left">
                  <span class="font-bold">Fecha de desactivación:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify">
                  {{ currentProject.fecha_desactivacion | moment('DD/MM/YYYY hh:mm a') }}
                </div>
              </div>

              <div
                class="flex w-full text-xs pt-2 tracking-wide "
                v-if="currentProject.id_curador !== null"
              >
                <div
                  class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs mb-2 text-left">
                  <span class="font-bold" v-if="currentProject.status !== 'NO REVISADO'">Verificado por:</span>
                </div>
                <div
                  class="w-9/12 block tracking-wider text-gray-700 text-xs mb-2 text-left text-justify">
                  {{ currentProject.nombre_curador }} {{ currentProject.apellido_curador }}
                </div>
              </div>  

              <div
                v-if="currentProject.file_type == 'video/mp4'"
                class="flex justify-center py-2 w-full"
              >
                <video
                  :src="currentProject.path_media_folder"
                  width="640"
                  height="480"
                  controls
                  controlslist="nodownload"
                />
              </div>
              <div
                class="flex justify-center py-2 w-8/12 mx-auto"
              >
                <v-lazy-image :src="currentProject.path_media_folder" />
              </div>


            </div>
          </div>
          <!--/seccion de informacion -->

            <!-- sección de ficha -->
            <div class="flex w-full">
            <div
              class="flex flex-col w-8/12 px-3 py-2 mx-auto my-3 bg-gray-400 rounded-lg shadow-xl"
            >
             <p
                v-if="currentProject.ficha_proyecto"
                class="pb-1 pt-2 text-sm text-center font-bold tracking-widest"
              >Ficha de información:</p>
              <div
                v-for="one_question in currentQuestions"
                :key="one_question.id"
              >
                <div v-if="one_question.texto != null">
                  <label
                    class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                    >{{ one_question.id_pregunta }}.-
                    {{ one_question.texto }} 
                    <template v-if="one_question.nota_para_registrante != ''">
                      ({{one_question.nota_para_registrante}})
                    </template> 
                  </label>

                  <div style="padding-left:20px;" >
                  <div v-if="one_question.tipo === 'ABIERTA'">
                    <input
                      class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                      type="text"
                      name="question"
                      value=""
                      disabled
                    />
                  </div>

                  <template v-if="one_question.tipo == 'SELECCION'">
                    <template
                      v-for="(opt, index) in one_question.opciones">
                      <div
                        class="flex items-center text-gray-700 font-bold">
                        <input
                          class="mr-2 leading-tight"
                          type="radio"
                          name="question"
                          disabled
                        />
                        <span>
                          {{opt}}
                        </span>
                      </div>
                    </template>
                  </template>

                  <template v-if="one_question.tipo == 'MULTISELECCION'">
                    <template
                      v-for="(opt, index) in one_question.opciones">
                      <div
                        class="flex items-center text-gray-700 font-bold">
                        <input
                          class="mr-2 leading-tight"
                          type="checkbox"
                          name="question"
                          disabled
                        />
                        <span>
                          {{opt}}
                        </span>
                      </div>
                    </template>
                  </template>                  

                  <template v-if="one_question.tipo == 'SELECCION_CONDICIONAL'">
                    <template
                      v-for="(opt, index) in one_question.opciones">
                      <div
                        class="flex items-center text-gray-700 font-bold">
                        <input
                          class="mr-2 leading-tight"
                          type="radio"
                          name="question"
                          :value="opt"
                          disabled
                        />
                        <span>
                          {{opt}}
                        </span>
                      </div>
                    </template>

                    <template
                      v-for="(opt, index) in one_question.pregunta_condicion">
                      <label
                        class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                        >{{ opt.id }}.-  <span style="color: #909696">({{ index }})</span>
                        {{ opt.texto }}
                        <template v-if="opt.nota_para_registrante != ''">
                          ({{ opt.nota_para_registrante}})
                        </template>
                      </label>

                      <template v-if="opt.tipo == 'SELECCION'">
                        <template
                          v-for="(opt1, index) in opt.opciones">
                          <div
                            class="flex items-center text-gray-700 font-bold">
                            <input
                              class="mr-2 leading-tight"
                              type="radio"
                              name="question"
                              :value="opt"
                              disabled
                            />
                            <span>
                              {{opt1}}
                            </span>
                          </div>
                        </template>
                      </template>

                      <div v-if="opt.tipo === 'ABIERTA'">
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          value=""
                          disabled
                        />
                      </div>

                      <template v-if="opt.tipo == 'CAMPOS'">
                        <template
                          v-for="(opt1, index) in opt.campos">
                          <div class="flex w-full items-center justify-center">
                            <label
                              class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                              >{{ opt1.texto }}</label
                            >
                            <input
                              class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              value=""
                              disabled
                            />
                          </div>
                        </template>
                      </template>
                    </template>
                  </template>

                  <template v-if="one_question.tipo == 'CAMPOS'">
                    <template
                      v-for="(opt, index) in one_question.campos">
                      <div class="flex w-full items-center justify-center">
                        <label
                          class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                          >{{ opt.texto }}</label
                        >
                        <input
                          class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          value=""
                          disabled
                        />
                      </div>
                    </template>
                  </template>


                  <template
                     v-if="one_question.hasOwnProperty('subpregunta')">
                    <template
                      v-for="(opt, index) in one_question.subpregunta"
                      >
                      <label
                        class="block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                        >{{ opt.id_pregunta }}.-
                        {{ opt.texto }}
                        <template v-if="opt.nota_para_registrante != ''">
                          ({{opt.nota_para_registrante}})
                        </template> 
                      </label>
                      <div v-if="opt.tipo === 'ABIERTA'">
                        <input
                          class="appearance-none block w-full bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                          type="text"
                          name="question"
                          value=""
                          disabled
                        />
                      </div>

                      <template v-if="opt.tipo == 'SELECCION'">
                        <template
                          v-for="(opt, index) in opt.opciones">
                          <div
                            class="flex items-center text-gray-700 font-bold">
                            <input
                              class="mr-2 leading-tight"
                              type="radio"
                              name="question"
                              :value="opt"
                              disabled
                            />
                            <span>
                              {{opt}}
                            </span>
                          </div>
                        </template>
                      </template>

                      <template v-if="opt.tipo == 'CAMPOS'">
                        <template
                          v-for="(opt, index) in opt.campos">
                          <div class="flex w-full items-center justify-center">
                            <label
                              class="w-3/12 block uppercase tracking-wider text-gray-700 text-xs font-bold mb-2 text-left"
                              >{{ opt.texto }}</label
                            >
                            <input
                              class="appearance-none block w-9/12 bg-gray-200 text-gray-700 border border-purple-400 rounded py-2 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                              type="text"
                              name="question"
                              value=""
                              disabled
                            />
                          </div>
                        </template>
                      </template>

                    </template>
                  </template>
                    
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
        <div 
         v-if = "currentProject.showButtons === true"
         >
          <button
              v-if = "currentProject.status === 'NO REVISADO' || (currentProject.status === 'EN REVISIÓN' && email === currentProject.email_curador)"
              v-on:click="updateStatusModal('APROBADO','APROBAR')"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >APROBAR</button> 
            <button
              v-if = "currentProject.status === 'NO REVISADO' || (currentProject.status === 'EN REVISIÓN' && email === currentProject.email_curador)"
              v-on:click="updateStatusModal('RECHAZADO','RECHAZAR')"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >RECHAZAR</button> 
            <button
              v-if = "currentProject.status === 'NO REVISADO' || (currentProject.status === 'EN REVISIÓN' && email === currentProject.email_curador)"
              v-on:click="newChatModal()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 mt-2 border border-secondary-color-dark hover:border-transparent rounded"
            >MENSAJES</button> 
        </div>
      </div>
    </div>

    <raising-modal
      :showing="showRaisingModal"
      @close="showRaisingModal = false"
      @updateAllRaising="fetchRaising"
    ></raising-modal> 

    <raising-chat-modal
      :showing="showCommentsModal"
      @close="closeChatModal"
    ></raising-chat-modal>

    <alert-dialog :showing="showingError">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Ha ocurrido un error</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingError = false"
        >Cerrar</button>
      </div>
    </alert-dialog>


        <alert-dialog :showing="showingDeleteConfirm">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Realmente desea eliminar el proyecto? Esta acción no se puede
          deshacer
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="realDeleteProject()"
        >
          Eliminar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingDeleteConfirm = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          Proyecto eliminado exitosamente
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingProjectNotEmpty">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          El proyecto no se puede eliminar, tiene fichas asociadas
        </div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-danger-color"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingProjectNotEmpty = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import moment from "moment";
import AlertDialog from "./AlertDialog";
/* import polygon from "../assets/polygonChapp.json"; */
import L from "leaflet";
import { LMap, LMarker, LGeoJson, LTileLayer } from "vue2-leaflet";
import * as esri from "esri-leaflet";
import { Icon } from "leaflet";
import EventBus from "../event-bus";
import RaisingModal from "./RaisingModal";
import RaisingChatModal from "./RaisingChatModal";
import tokml from "tokml"
import shpwrite from "shp-write"

export default {
  name: "projects-evalue-list",
  data() {
    return {
      geojsonRouter: null,
      raising: [],
      currentProject: {},
      currentQuestions: [],
      search: "",
      raisingOrder: "downward",
      statusFilterRaising: "NO REVISADOS",
      email: localStorage.getItem("email"),
      category: localStorage.getItem("category"),
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      showingError: false,
      /* polygon: polygon, */
      zoom: 12,
      center: [20.58651, -89.01501],
      showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false
      },
      chatRaising: null,
      chartList: null,
      showChatModal: false,
      showRaisingModal: false,
      showCommentsModal: false,
      showingDeleteConfirm: false,
      showingSuccessDelete: false,
      showingSuccessDelete: false,
      showingProjectNotEmpty: false,
      urlBasemap: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      categoryFilter: "-1",
      categories: [
        {
          id: 0,
          nombre: "Desactivado"
        },
        {
          id: 1,
          nombre: "Activo"
        }
      ],
    };
  },
  components: {
    LMap,
    LMarker,
    LGeoJson,
    LTileLayer,
    AlertDialog,
    RaisingModal,
    RaisingChatModal
  },
  mounted() {
    EventBus.$emit("updateNotification", {});
    this.fetchRaising();
  },
  methods: {
    onMapReady: function() {
       this.$nextTick(() => {
        let that = this;
        const map = this.$refs.map.mapObject;
        //esri.basemapLayer("Topographic").addTo(map);
        this.leafletMap = map;

        this.kmzParser = new L.KMZParser({
          onKMZLoaded: function(layer, name) {
            that.geojsonRouter = null;

            if(that.layerKmz != null){
              map.removeLayer(that.layerKmz);
              that.layerKmz = null;
            }

            that.layerKmz = layer;
            layer.addTo(map);
          }
        });
      });
    },

    showPolygonInMap(){
      if (this.currentProject.geometria !== null) {
        if(this.currentProject.kml!=null){
          const type = this.currentProject.kml.split(".")[1];
          if(type=="kml"){
            this.resetFileGeometryInMap();
            this.geojsonRouter = null;
            var oReq = new XMLHttpRequest();
            oReq.addEventListener("load", () => {
              this.loadKml(oReq.responseText)
            });
            oReq.open("GET", "apidev/"+this.currentProject.kml);
            oReq.send();
          }

          if(type=="kmz"){
            this.resetFileGeometryInMap();
            this.kmzParser.load("apidev/"+this.currentProject.kml)
          }
        }else{
          this.resetFileGeometryInMap();
          this.geojsonRouter = this.currentProject.geometria;
          if(this.geojsonRouter){
            let boundingBoxGeojson = L.geoJSON(this.geojsonRouter);
            let boundingBox = boundingBoxGeojson.getBounds();
            this.$refs.map.mapObject.fitBounds(boundingBox);
          }
        }
      } else {
        this.resetFileGeometryInMap();
        this.geojsonRouter = null;
      }

    },

    resetFileGeometryInMap(){
      if(this.layerKmz != null){
        this.leafletMap.removeLayer(this.layerKmz);
        this.layerKmz = null;
      }

      if(this.layerKml != null){
        this.leafletMap.removeLayer(this.layerKml);
        this.layerKml = null;
      }
    },

    updateSelectRegister(){
      if(this.filteredRaising.length > 0){
        this.selectRaising(this.filteredRaising[0])
      }
    },

    fetchRaising() {
      this.$root.$emit("showLoading");
      this.axios
        .post("apidev/projects/getAllProjectGeneral", {
          'email': this.email,
          'category': this.category
        }, this.config)
        .then(response => {
          this.raising = response.data.projects;
          this.$root.$emit("hideLoading");
          if(this.filteredRaising.length > 0){
            this.selectRaising(this.filteredRaising[0])
            //this.showPolygonInMap();
          }
        })
        .catch(error => {
          this.catchError(error)
          this.showingError = false;
        });
    },

    selectRaising(raising) {
      this.$root.$emit("showLoading");
      this.currentProject = raising;

      if(this.currentProject.id_propietario == localStorage.getItem("user_id")){
        this.currentProject.showButtons = false;
      }else{
        this.currentProject.showButtons = true;
      }

      this.showPolygonInMap();
      this.axios
        .post(
          "apidev/projects/getFichaRespuestasJson", 
          {
            "id_project": this.currentProject.id 
          }, 
          this.config
        )
        .then(response => {
          this.currentQuestions = response.data.answers;
          this.$root.$emit("hideLoading");
        })
        .catch(error => this.catchError(error));
    },

    changeRaisingOrder() {
      this.raisingOrder = (this.raisingOrder === "upward") ? "downward" : "upward";
    },

    updateStatusModal(status, label) {
      this.showRaisingModal = true;
      EventBus.$emit("statusModal", {
        'raising_id': this.currentProject.id,
        'status': status,
        'label': label,
        'menu': 'PROYECTO'
      });
    },

    newChatModal(){
      this.showCommentsModal = true;
      EventBus.$emit("showChatModal", {
        "raising_id":  parseInt(this.currentProject.id),
        "is_curador": true,
        'menu': 'PROYECTO'
      });
    },
    closeChatModal(){
      this.showCommentsModal=false
      this.fetchRaising();
    },
    joinCategories(opciones) {
      let string_categories = ""
      for (const property in opciones) {
        if(opciones[property]){
          string_categories += property + ", "
        }
      }

      return string_categories
    },
    catchError(error){
      if (error.response.status == 400 || error.response.status == 401) {
        if (
          error.response.data.name === "TokenExpiredError" ||
          error.response.data.name === "InvalidTokenError" ||
          error.response.data.name === "JsonWebTokenError"
        ) {
          this.$router.push({ path: "/login" });
        }
      }
      
      this.$root.$emit("hideLoading");
    },
    loadDefaultImg(event) {
      event.target.src = "https://via.placeholder.com/80";
    },
    toGeojsonFile(){
      console.log("toGeojsonFile", this.currentProject)
      let geojsonObject = this.currentProject.geometria

      let geojsonProperties = {}
      geojsonProperties["proyecto"]     = this.currentProject.nombre;
      geojsonProperties["descripción"]       = this.currentProject.descripcion; 
      geojsonProperties["institucion"]       = this.currentProject.institucion; 
      geojsonProperties["fecha"]        = new Date(this.currentProject.fecha_creacion);

      this.currentProject.geometria.properties = geojsonProperties

      var convertedData = 'text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(geojsonObject)); //encodeURIComponent recibe el geojson como texto
      document.getElementById('downGeojson').setAttribute('href', 'data:' + convertedData);      
      document.getElementById('downGeojson').setAttribute('download',this.currentProject.nombre+'.geojson');      

    },
    toKMLFile(){
      console.log("toKMLFile")
      console.log(this.geojsonGeometries)
      let geojsonObject = this.currentProject.geometria
      var kml = tokml(geojsonObject); //tokml recibe el geojson como objecto
      var convertedData = 'application/xml;charset=utf-8,' + encodeURIComponent(kml);

      // if you want to use the official MIME type for KML
      // var convertedData = 'application/vnd.google-earth.kml+xml;charset=utf-8,'+ 
      // encodeURIComponent(kml);

      document.getElementById('downKML').setAttribute('href', 'data:' + convertedData); 
      document.getElementById('downKML').setAttribute('download', this.currentProject.nombre+'.kml');
    },
    toSHPFile(){
      console.log("toSHPFile")
      var options = {
          folder: this.currentProject.nombre,
          types: {
              point: 'puntos',
              polygon: 'polígonos',
              line: 'líneas'
          }
      }

      let info = {
        "type": "FeatureCollection",
        "features": [this.currentProject.geometria]
      }
      // a GeoJSON bridge for features
      shpwrite.download(info, options) //shpwrite recibe el geojson como objeto
    },
    realDeleteProject() {
      this.$root.$emit("showLoading");
      this.axios
        .delete(
          "../apidev/projects/deleteProject/" + this.currentProject.id,
          {
            user_id: localStorage.getItem("user_id"),
            activo: "false",
          },
          this.config
        )
        .then((response) => {
          if (response["data"]["status"] == "Proyecto eliminado") {
            this.currentProject = {};
            this.fetchRaising();
            this.search = "";
            this.showingDeleteConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingSuccessDelete = true;
          }

          if (
            response["data"]["status"] == "El proyecto tiene fichas asociadas"
          ) {
            this.showingDeleteConfirm = false;
            this.$root.$emit("hideLoading");
            this.showingProjectNotEmpty = true;
            
          }
        })
        .catch((error) => {
          console.log("ocurrió un error al eliminar: ", error);
          this.showingDeleteConfirm = false;
          this.$root.$emit("hideLoading");
          this.showingError = true;
        });
    },
  },
  computed: {
    filteredRaising() {
      return this.raising
        .filter(elem => {
          let date = moment(elem.fecha_creacion).format("DD/MM/YYYY");
          let new_string_search =  `${date.toLowerCase()} ${elem.id.toString()} ${elem.titulo.toLowerCase()}`;
          switch (this.statusFilterRaising) {
            case "TODOS":
              return (
                (new_string_search.includes(this.search.toLowerCase())) &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "RECHAZADOS":
              return (
                (new_string_search.includes(this.search.toLowerCase())) &&
                elem.status == "RECHAZADO" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "NO REVISADOS":
              return (
                (new_string_search.includes(this.search.toLowerCase())) &&
                elem.status == "NO REVISADO" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "EN REVISIÓN":
              return (
                (new_string_search.includes(this.search.toLowerCase())) &&
                elem.status == "EN REVISIÓN"  &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            case "APROBADOS":
              return (
                (new_string_search.includes(this.search.toLowerCase())) &&
                elem.status == "APROBADO" &&
                (this.categoryFilter === "-1" ||
                  Number(elem.activo) === parseInt(this.categoryFilter))
              );
            default:
              break;
          }
        })
        .sort((a, b) => {
          if (this.raisingOrder === "upward") {
            return new Date(a.fecha_creacion) - new Date(b.fecha_creacion);
          } else {
            return new Date(b.fecha_creacion) - new Date(a.fecha_creacion);
          }
        });
    },
    filteredRaisingByAll(){
      return this.raising;
    },
    filteredRaisingByOpen() {
      return this.raising.filter(elem => elem.status == "NO REVISADO");
    },
    filteredRaisingByAssigned() {
      return this.raising.filter(elem => elem.status == "EN REVISIÓN");
    },
    filteredRaisingByCanceled() {
      return this.raising.filter(elem => elem.status == "RECHAZADO");
    },
    filteredRaisingByAttended() {
      return this.raising.filter(elem => elem.status == "APROBADO");
    }

    //NO REVISADO, EN REVISION, APROBADO, RECHAZADO
  }
};
</script>

<style scoped>
textarea {
  resize: none;
}
</style>